<template>
  <v-app>
    <div :class="{ custom_toolbar: true, dark_mode: $vuetify.theme.dark }">
      <v-container>
        <div style="display: inline-block; text-align: center">
          <img
            :src="logo_url"
            style="cursor: pointer"
            @click="openHome"
            alt="schmuckliCloud"
            height="55"
          />
          <p
            class="connectionInfo dark_mode"
            :title="'Connected to ' + connection_url"
          >
            {{
              connection_url == ""
                ? "&nbsp;"
                : connection_url.replace("https://", "").replace("http://", "")
            }}
          </p>
        </div>
        <v-menu
          v-model="menu"
          :close-on-content-click="false"
          :nudge-width="200"
          offset-x
        >
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              color="default"
              v-show="isLoggedIn"
              style="float: right; margin-top: 10px; padding-left: 7px"
              text
              v-on="on"
            >
              <v-icon>account_circle</v-icon>
            </v-btn>
          </template>

          <v-card>
            <v-list>
              <v-list-item>
                <v-list-item-avatar>
                  <v-icon style="font-size: 40px">account_circle</v-icon>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title>{{
                    profile_data.first_name + " " + profile_data.last_name
                  }}</v-list-item-title>
                  <v-list-item-subtitle>{{
                    profile_data.email
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <div style="margin: 10px auto 10px auto; width: 200px">
              <v-select
                v-if="selected_project"
                style="width: 200px"
                @change="changedProject"
                v-model="selected_project"
                :items="projects"
                label="Current project"
              ></v-select>
              <v-switch
                style="margin: 0"
                label="Dark mode"
                @change="updateTheme"
                v-model="$vuetify.theme.dark"
              ></v-switch>
            </div>
            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn text @click="openProfileSettings">Settings</v-btn>
              <v-btn color="primary" text @click="logout">Logout</v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </v-container>
    </div>

    <v-content>
      <v-container>
        <transition name="fade" mode="out-in">
          <router-view />
        </transition>
      </v-container>
    </v-content>

    <v-footer style="margin-top: 30px">
      <v-container>
        <v-layout row wrap>
          <v-flex sm12 md4 xs12>
            <p :class="{ dark_mode: $vuetify.theme.dark }">
              <a href="https://schmuckli.cloud" title="About"
                ><i class="fal fa-info-circle" style="margin-right: 5px"></i
                >About</a
              >
              <br />
              <a href="https://files.schmuckli.cloud" title="Files">
                <i class="fal fa-archive" style="margin-right: 5px"></i
                >Files</a>
              <br />
              <a href="https://docs.schmuckli.cloud" title="Documentation"
                ><i class="fal fa-file-alt" style="margin-left:2px;margin-right: 6px"></i
                >Docs</a
              >
              <br />
              <a
                href="https://cms.schmuckli.cloud"
                title="Content Management System"
                ><i class="fal fa-wrench" style="margin-right: 5px"></i
                >CMS</a
              >
            </p>
          </v-flex>
          <v-flex sm12 md4 xs12>
            <p :class="{ dark_mode: $vuetify.theme.dark }">
              <a href="https://schmuckli.cloud/imprint">
                <i class="fal fa-info-circle" style="margin-right: 5px"></i
                >Imprint</a>
              <br />
              <a href="https://schmuckli.cloud/privacy"><i class="fal fa-lock" style="margin-left:1px;margin-right: 6px"></i
                >Privacy</a>
            </p>
          </v-flex>
          <v-flex sm12 md4 xs12 style="text-align: right">
            <p>&copy; 2019 - {{ new Date().getFullYear() }} by schmuckli.net</p>
          </v-flex>
        </v-layout>
      </v-container>
    </v-footer>

    <!-- Notification -->
    <v-snackbar v-model="notification">
      {{ notification_text }}
      <v-btn depressed @click="notification = ''">Close</v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
import Vue from "vue";
import { User } from "./logic/User";
import { Profile } from "./logic/Profile";
import { Projects } from "./logic/Projects";
import { Notifications, NotificationsReceiver } from "./notification";
import * as Vars from "./logic/Vars";

export default {
  name: "App",
  data() {
    return {
      url: window.location.origin,
      menu: false,

      profile_data: {
        first_name: "...",
        last_name: "...",
        email: "...",
      },
      isLoggedIn: false,

      projects: [],
      selected_project: 0,

      connection_url: "",
    };
  },
  mounted() {
    this.profileMenuAdaption();
    this.getTheme();
    this.loadProjects();
    this.loadConnectionUrl();
  },
  watch: {
    $route() {
      this.profileMenuAdaption();
      this.setCurrentProject();
      this.loadConnectionUrl();
    },
  },
  computed: {
    /* Notification */
    notification: {
      get() {
        return NotificationsReceiver.notification !== "";
      },
      set() {
        Notifications.show("");
      },
    },
    notification_text() {
      return NotificationsReceiver.notification;
    },
    logo_url() {
      if (this.$vuetify.theme.dark) {
        return this.url + "/assets/schmucklicloud_label_white.png";
      } else {
        return this.url + "/assets/schmucklicloud_label_black.png";
      }
    },
  },
  methods: {
    loadConnectionUrl() {
      if (this.$route.path == "/login") {
        this.connection_url = "";
      } else {
        this.connection_url = Vars.API_ENDPOINT;
      }
    },
    openAccount() {
      this.$router.push("/login");
    },
    openHome() {
      this.$router.push("/");
    },
    openProfileSettings() {
      this.menu = false;
      this.$router.push("/profile");
    },
    logout() {
      this.menu = false;
      User.logoutAndRedirect(this);
    },
    getTheme() {
      var isDark = window.localStorage.getItem("isDark");
      if (isDark === null) {
        if (
          window.matchMedia &&
          window.matchMedia("(prefers-color-scheme: dark)").matches
        ) {
          this.$vuetify.theme.dark = true;
        } else {
          this.$vuetify.theme.dark = false;
        }
      } else if (isDark === "true") {
        this.$vuetify.theme.dark = true;
      } else {
        this.$vuetify.theme.dark = false;
      }
    },
    async loadProjects() {
      var response = await Projects.load();
      if (response.status === 200) {
        var projects = response.body;
        projects.forEach(
          function (project) {
            this.projects.push({
              text: project.name,
              value: String(project.id),
            });
          }.bind(this)
        );
        this.setCurrentProject();
      }
    },
    setCurrentProject() {
      var project_id = this.$route.params.project_id
        ? this.$route.params.project_id
        : this.$route.params.id;
      this.selected_project = project_id ? String(project_id) : undefined;

      if (this.selected_project !== undefined) {
        var current_project = this.projects.find((project) => {
          return String(project.value) === String(this.selected_project);
        });
        Vue.prototype._current_project_name = current_project ? current_project.text : "";
      } else {
        Vue.prototype._current_project_name = "";
      }
    },
    changedProject() {
      var route = this.$route.path.split("/");
      route[2] = this.selected_project;
      this.$router.replace(route.join("/"));
      setTimeout(function () {
        window.location.reload();
      }, 200);
    },
    updateTheme() {
      window.localStorage.setItem("isDark", this.$vuetify.theme.dark);
    },
    async fetchUserInformation() {
      this.profile_data = (await Profile.load()).body;
    },
    async profileMenuAdaption() {
      try {
        if (await User.isSignedIn()) {
          this.fetchUserInformation();
          this.isLoggedIn = true;
        } else {
          this.isLoggedIn = false;
        }
      } catch (e) {
        localStorage.removeItem("api_host");
        localStorage.removeItem("_console_token");
        window.location.reload();
      }
    },
  },
};
</script>

<style>
@import url("./assets/css/layout.css");
@import url("./assets/css/dashboard.css");
@import "~vue-wysiwyg/dist/vueWysiwyg.css";

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
